var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resume-page-wrapper"},[(_vm.activeSection == 1)?_c('Cvs',{on:{"switchSection":_vm.switchSection}}):_vm._e(),(_vm.activeSection == 2)?_c('CvsTemplate',{attrs:{"payload":_vm.editorPayload},on:{"switchSection":_vm.switchSection,"resetEditorPayload":function($event){_vm.editorPayload = null}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }